<template>
  <article class="lesson">
    <h1 v-if="!hideTitle">
      {{ lesson.title }} <TextToSpeech :text="lesson.title" />
    </h1>
    <LessonSection
      v-for="lessonSection in lessonSections"
      :key="lessonSection.id"
      :data="lessonSection"
    />
  </article>
</template>

<script>
import LessonSection from './LessonSection'
import { LessonStoreNamespacedTypes } from '../../store/lessons'
import TextToSpeech from '../accessibility/TextToSpeech'
import { LessonSectionType } from '../../enums'

export default {
  name: 'Lesson',
  components: { LessonSection, TextToSpeech },
  props: {
    lessonId: {
      type: Number,
      required: true,
    },
    hideQuestions: {
      type: Boolean,
      required: false,
    },
    hideTitle: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    lesson() {
      return this.$store.getters[LessonStoreNamespacedTypes.getters.GET_LESSON](
        this.lessonId
      )
    },
    lessonSections() {
      const sections = this.lesson.lessonSection || []

      if (this.hideQuestions) {
        return sections.filter(
          lessonSection => lessonSection.type !== LessonSectionType.QUESTION
        )
      }

      return sections
    },
  },
}
</script>

<style></style>
